import React, { useEffect } from "react"
import { useParams } from "react-router"
import RenderSummaryHeader from "./components/RenderSummaryHeader/RenderSummaryHeader"
import RenderDiagnosticReport from "./components/RenderDiagnosticReport/RenderDiagnosticReport"

function SummaryView({ patientDetail, smartSummaryDetails, scroll }: any) {

  const { patientId }: any = useParams()

  useEffect(() => {
    if (scroll) {
      scroll()
    }
  }, [patientId, smartSummaryDetails])

  return (
    <div className="content-container">
      {
        smartSummaryDetails && (
          <>
            <RenderSummaryHeader
              patientDetail={patientDetail}
              smartSummaryData={smartSummaryDetails}
            />

            <RenderDiagnosticReport
              smartSummaryData={smartSummaryDetails}
            />
          </>
        )
      }
    </div>
  )
}

export default SummaryView
